import Image from 'next/image';
import React from 'react';

export default function LoadingError(props: {
  title?: string;
  description?: string;
  error?: any;
}) {
  return (
    <div className="flex size-full h-48 flex-col items-center justify-center">
      <Image
        className="block size-[72px]"
        width={40}
        height={40}
        src="/assets/svgs/WarningWarning.svg"
        alt={props.title ?? 'Error Icon'}
      />
      {props.title && <p className="font-garnettBlack"> {props.title} </p>}
      {props.description && <p> {props.description} </p>}
    </div>
  );
}
